import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import AssetRequestManagementTable from '../assetRequestManagementWidgets/AssetRequestManagementTable'
import { searchAssetRequestManagement } from '../../redux/actions/assetRequestManagement'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { doneLoading, startLoading } from '../../utils/loading'
import { sessionRemoveItem, sessionSetItemObj } from '../../utils/sessionHelpers'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'

export default function AssetRequestManagementApproveWidgets(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.result || [])

  const history = useHistory()

  const onSearch = async (request, pagenumber, pagesize) => {
    console.log('onSearch', request)

    setIsLoading(true)
    startLoading()

    try {
      var response = await searchAssetRequestManagement(request, pagenumber, pagesize)
      console.log('response ', response.model)
      if (response.model) {
        setDataTable(response?.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelecetAssetRequest = async (rowData) => {
    console.log('handleSelecetAssetRequest ', rowData)

    if (rowData) {
      sessionSetItemObj('bookingInfo', rowData)
    } else {
      sessionRemoveItem('bookingInfo')
    }

    history.push({
      pathname: pathname.durableArticles.AssetRequestManagementDetail,
    })
  }

  const handleSearchAssetRequest = async (
    pagesize,
    pagenumber,
    requestForUseDocNo,
    projectCode,
    projectName,
    startDate,
    endDate,
    requestForUseStatus
  ) => {
    const request = {
      pagesize,
      pagenumber,
      requestForUseDocNo,
      projectCode,
      projectName,
      startDate,
      endDate,
      requestForUseStatus,
    }

    onSearch(request, pagenumber, pagesize)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header || ' '} bordered>
        <AssetRequestManagementTable
          schema={dataTable}
          searchForm={formSchema.searchForm}
          loading={isLoading}
          onSearch={onSearch}
          onSelect={handleSelecetAssetRequest}
          disableAdd={true}
          onReload={handleSearchAssetRequest}
        />
      </Panel>

      <br />

      {/* {formDetailSchema && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={formDetailSchema.inputForm.header || ' '}
          bordered
        >
          <AssetRequestManagementDetailTable
            schema={formDetailSchema.inputForm}
            dataTable={dataDetailTable}
            loading={isLoading}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            isApprover
          />
          <>
            <div>
              <br />
              <Row>
                {isError && <Message showIcon type="error" description={isError} />}
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {!formDetailSchema?.disabled && (
                    <>
                      <EditButton
                        disabled={isLoading}
                        onClick={() => setIsShowConfirmSendBack(true)}
                        icon="close"
                      >
                        {formDetailSchema.button.concelReserve || 'ส่งกลับแก้ไข'}
                      </EditButton>
                      <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)} icon="send">
                        {formDetailSchema.button.request || 'ขออนุมัติ'}
                      </SaveButton>
                      <CancelButton
                        onClick={() => {
                          setFormDetailSchema()
                        }}
                      >
                        {formDetailSchema.button.cancel || 'ยกเลิก'}
                      </CancelButton>
                    </>
                  )}
                </Col>
              </Row>
            </div>
          </>
        </Panel>
      )} */}

      {/* {formDetailSchema && (
        <ConfirmWidget
          title={'ยืนยัน' + formDetailSchema.button.request || 'ขออนุมัติ'}
          show={isShowConfirm}
          //detail={'ยืนยันการบันทึก'}
          onCancle={() => setIsShowConfirm(false)}
          onConfirm={handleCallService}
        />
      )} */}

      {/* {formDetailSchema && (
        <ConfirmWidget
          title={'ยืนยัน' + formDetailSchema.button.concelReserve || 'ส่งกลับแก้ไข'}
          show={isShowConfirmSendBack}
          //detail={'ยืนยันลบเอกสาร'}
          onCancle={() => setIsShowConfirmSendBack(false)}
          onConfirm={handleCallSendBack}
        />
      )} */}
    </>
  )
}
